module.exports = __webpack_public_path__ + "static/media/sprite_long-arrow.27f9a9fc.svg";